module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av229-4f85bfce8c1b9caeddba5532ed769277.jpg";